window.Varellea.register('site-header', root => {
  const controller = new AbortController();
  const signal = controller.signal;
  const drawer = root.querySelector('[data-mobile-drawer]');
  const opener = root.querySelector('[data-drawer-open]');
  const closer = root.querySelector('[data-drawer-close]');
  const disclosures = [...root.querySelectorAll('[data-nav-disclosure]')];
  let resizeObserver;
  let returnFocus;

  function syncDisclosure(details) {
    details.querySelector('summary')?.setAttribute('aria-expanded', String(details.open));
  }
  function closeDisclosures(except) {
    for (const details of disclosures) {
      if (details !== except && details.open) {
        details.open = false;
        syncDisclosure(details);
      }
    }
  }
  function updateHeader() {
    if (root.dataset.transparent !== 'true') return;
    root.classList.toggle('is-solid', window.scrollY > 12);
    root.parentElement.style.marginBottom = `-${root.offsetHeight}px`;
  }
  function openDrawer() {
    if (!drawer || drawer.open) return;
    returnFocus = document.activeElement;
    drawer.showModal();
    opener?.setAttribute('aria-expanded', 'true');
    closer?.focus();
  }
  function closeDrawer() {
    if (drawer?.open) drawer.close();
  }
  return {
    connect() {
      opener?.addEventListener('click', openDrawer, { signal });
      closer?.addEventListener('click', closeDrawer, { signal });
      drawer?.addEventListener('close', () => {
        opener?.setAttribute('aria-expanded', 'false');
        (returnFocus?.isConnected ? returnFocus : opener)?.focus();
      }, { signal });
      drawer?.addEventListener('click', event => {
        if (event.target === drawer) closeDrawer();
      }, { signal });
      for (const details of disclosures) {
        details.addEventListener('toggle', () => {
          syncDisclosure(details);
          if (details.open) closeDisclosures(details);
        }, { signal });
        details.addEventListener('keydown', event => {
          if (event.key === 'Escape' && details.open) {
            details.open = false;
            syncDisclosure(details);
            details.querySelector('summary')?.focus();
          }
        }, { signal });
        details.addEventListener('mouseenter', () => {
          if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
            closeDisclosures(details);
            details.open = true;
            syncDisclosure(details);
          }
        }, { signal });
        details.addEventListener('mouseleave', () => {
          if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && !details.contains(document.activeElement)) {
            details.open = false;
            syncDisclosure(details);
          }
        }, { signal });
      }
      document.addEventListener('click', event => {
        if (!root.contains(event.target)) closeDisclosures();
      }, { signal });
      root.addEventListener('varellea:block:select', event => {
        const details = event.target.closest('[data-nav-disclosure]');
        if (details) {
          closeDisclosures(details);
          details.open = true;
          syncDisclosure(details);
        }
      }, { signal });
      root.addEventListener('varellea:block:deselect', () => closeDisclosures(), { signal });
      window.addEventListener('scroll', updateHeader, { passive: true, signal });
      resizeObserver = new ResizeObserver(updateHeader);
      resizeObserver.observe(root);
      updateHeader();
    },
    disconnect() {
      controller.abort();
      resizeObserver?.disconnect();
      closeDrawer();
      closeDisclosures();
      root.parentElement.style.marginBottom = '';
    }
  };
});
